import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, toRefs, onMounted, useContext, watch } from "@nuxtjs/composition-api";
import { MetaUser } from "~/core/models/MetaUser";
import { ACTIONS as USER_FEEDBACK_ACTIONS } from "~/store/affility/user/feedback/names";
import { ACTIONS as TOAST_ACTIONS } from "~/store/affility/user/feedback/modals/toast-notification/names";
import { ACTIONS as FULL_LOADER_ACTIONS } from "~/store/affility/user/feedback/modals/full-loader/names";
import ApiService from "~/core/services/api-interaction/ApiService";
import {ACTIONS as AUTH_ACTIONS} from '~/store/affility/user/auth/names';

interface Props {
    initialFormData?: Object,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TwoFactorSendCode',
  props: {
    initialFormData: { default: null }
  },
  emits: ['onBack', 'onSuccessfullySignIn'],
  setup(__props: any, { emit: $emit }) {

const props = __props as { initialFormData: Object };



const context = useContext();
const CODE_RESEND_INTERVAL = 60000;
const lastCodeDate = ref(Date.now());
const resentActive = ref(false);
const confirmLoading = ref(false);
const showNotEmailNotVerified = ref(false);
const authCode = ref('');
const authToken = ref('');
const authStatus = ref('');
const userEmail = ref('');
const codeError = ref('');

const {
    initialFormData
} = toRefs(props);



const isCodeValid = computed(() => {
    return authCode.value && authCode.value.length && authCode.value.length === 6;
})

const user: MetaUser = computed(() => context.store.getters['application/driver/authUser']);

const isFromLogin = computed(() => {
    return initialFormData.value;
})

const openFullScreenPopup = () => {
    context.store.dispatch(
        `affility/user/feedback/modals/full-loader/${FULL_LOADER_ACTIONS.OPEN_FULL_PAGE_LOADING}`,
        context.i18n.t('please_wait')
    );
}

const closeFullScreenPopup = () => {
    context.store.dispatch(`affility/user/feedback/modals/full-loader/${FULL_LOADER_ACTIONS.CLOSE_FULL_PAGE_LOADING}`);
}

const handleContinue = async () => {
    if (authToken.value) {
        const token = authToken.value;
        const code = authCode.value;
        const payload = { token, code };

        if (!isFromLogin.value) {
            payload.status = authStatus.value;
        }

        confirmLoading.value = true;
        openFullScreenPopup();
        try {
            const response = await ApiService.post('/user/verify-two-factor-auth-code', payload);

            if (isFromLogin.value) {
                if (response.data?.token && response.data?.user) {
                    await context.$auth.setUserToken(response.data.token);
                    $emit('onSuccessfullySignIn');
                } else {
                    onError();
                }

                confirmLoading.value = false;
                closeFullScreenPopup();
            } else {
                await context.store.dispatch(`affility/user/auth/${AUTH_ACTIONS.UPDATE_USER_AUTH_DATA}`, {
                    isEnableTwoFactor: authStatus.value,
                });

                const messagePayload = authStatus.value ? {
                    title: context.i18n.t("two_factor_authentication_is_enabled"),
                    desc: context.i18n.t("account_more_secure_need_password_and_code_next_sign_in"),
                } : {
                    title: context.i18n.t("two_factor_authentication_is_disabled"),
                    desc: context.i18n.t("two_factor_authentication_disabled_next_time_only_password"),
                }

                confirmLoading.value = false;
                closeFullScreenPopup();
                $emit('onSuccessfullySignIn');

                context.store.dispatch(
                    `affility/user/feedback/${USER_FEEDBACK_ACTIONS.SHOW_SUCCESS_MODAL}`,
                    messagePayload
                );
            }
        } catch (e) {
            console.log(e);
            codeError.value = 'code_entered_is_incorrect_check_and_try_again';

            confirmLoading.value = false;
            closeFullScreenPopup();
        }
    }
}

const handleResendCode = async () => {
    lastCodeDate.value = Date.now();
    resentActive.value = false;

    if (authToken.value) {
        const token = authToken.value;
        try {
            await ApiService.post('/user/two-factor-auth-send-email', {
                token
            });
            authCode.value = '';
            context.store.dispatch(`affility/user/feedback/modals/toast-notification/${TOAST_ACTIONS.SHOW_INFO_TOAST}`, {
                description: context.i18n.t('new_code_sent_check_your_email'),
            })
        } catch (e) {
            console.log(e);
            onError();
        }
    }
}

const onError = () => {
    let errorText = "Something went wrong, please refresh the page and try again";
    context.store.dispatch(`affility/user/feedback/modals/toast-notification/${TOAST_ACTIONS.SHOW_ERROR_TOAST}`, {
        description: context.i18n.t(errorText),
    })
}

onMounted(async () => {
    // Entered from login page
    if (initialFormData.value && initialFormData.value.token) {
        showNotEmailNotVerified.value = false;
        authToken.value = initialFormData.value.token;
        userEmail.value = initialFormData.value.email;
    }

    // Entered from settings
    else if (!isFromLogin.value) {
        if (user.value && user.value.isEmailVerified) {
            authStatus.value = !user.value?.isEnableTwoFactor;
            userEmail.value = user.value.email;
            showNotEmailNotVerified.value = false;
            try {
                const response = await ApiService.post('/user/two-factor-auth-status', {
                    status: authStatus.value
                });

                authToken.value = response.data.token;
            } catch (e) {
                console.log(e)
                onError();
            }
        } else if (user.value && !user.value.isEmailVerified) {
            showNotEmailNotVerified.value = true;
        }
    }
})

watch(authCode, () => {
    codeError.value = '';
})

return { __sfc: true,props, context, CODE_RESEND_INTERVAL, lastCodeDate, resentActive, confirmLoading, showNotEmailNotVerified, authCode, authToken, authStatus, userEmail, codeError, initialFormData, $emit, isCodeValid, user, isFromLogin, openFullScreenPopup, closeFullScreenPopup, handleContinue, handleResendCode, onError }
}

})